import React from 'react';
import { GrayBackground } from 'components/atoms';

const ContainerForm: React.FC = ({ children }) => {
  return <GrayBackground>{children}</GrayBackground>;
};

export default ContainerForm;
